export default __webpack_public_path__ + "static/media/100_19518.d175841a.jpg";